// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import { login as apiLogin, logout as apiLogout, getStoredUser } from '../services/authService'; // Simplified service

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Handle initial load

  useEffect(() => {
    // Check local storage on initial load
    const storedUser = getStoredUser();
    if (storedUser) {
      setUser(storedUser);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    // In real app, call API. Here, simulate with authService
    const loggedInUser = await apiLogin(username, password);
    if (loggedInUser) {
      setUser(loggedInUser);
      return true;
    }
    setUser(null); // Ensure user is null on failed login
    return false;
  };

  const logout = () => {
    apiLogout();
    setUser(null);
  };

  // isLoading prevents rendering protected routes before auth status is known
  if (loading) {
     return <div>Loading Authentication...</div>; // Or a spinner
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;